GP.GPMod('ActivityPane',function(self) {
    'use strict';

    var vent  = null;
    var _util = null;
    var _log  = null;

    var data  = {
        // check and initialize a few params
        init: function() {
            vent  = self.vent;
            _util = self.app.Util;
            _log  = self.app.Util.log;

            // change max_growls to 1 and 5 min between for smokeandpoke, sexygamerz, bbwz or bootycallz
            if (_util.check_limited_growls_host()) {
                data.max_growls = 1;
            }

            data.matchgame_reminder_growl_open = false;
        },
        curr_page:     1,
        total_pages:   1,
        fetching_page: false,
        counts: {
            total_new:       0,
            logged_in:       0,
            viewed_profile:  0,
            viewed_feed:     0,
            hovered_feed:    0,
            favorite_added:  0,
            friend_request:  0,
            now_friends:     0,
            want_to_meet:    0,
            pic_rated:       0,
            content_like:    0,
            content_comment: 0,
            comment_reply:   0,
            status_like:     0,
            status_comment:  0,
            comments:        0,
            free_growl:      0,
            emoji_reaction:  0,
        },
        // logged_in, viewed_profile, viewed_feed, hovered_feed, favorite_added, friend_request, pic_rated
        // content_like, content_comment, comment_reply, video_like, video_comment, status_like, status_comment
        jgrowl_types: ['li','pv','vf','hf','fa','fr','pr','cl','cc','cr','vl','vc','sl','sc','pp','pc','ss','er','pu','new_message','free_growl','generic'],
        growl_expire: 5000,

        settings_growl_threshhold: 2,       // how many growls a user must close to see the special settings growl
        max_growls: 2,                      // how many growls can be shown at once
        growls_closed:             0,       // how many growls the user has closed
        settings_growl_shown:      false,   // seen the special growl to take them to the settings

        matchgame_reminder_growl_open: false,

        // growl functions will get added to this array and we will check every few seconds
        // and display the next one instead of immediately upon arrival
        queue: [],
        queue_interval: 3000, // how many seconds between showing activity/growl
        queue_interval_ref:   null, // reference for our setInterval loop for the queue of activities/growls to show

        // flag to set from other modules for when we want to hide the growls for whatever reason
        hide_growls: false,

        safe_thumb_woman: '//cachecdn.fling.com/images/thumbs/nudev2-' + Math.floor((Math.random() * 5) + 1) + '-S.jpg',
        safe_thumb_man:   '//cachecdn.fling.com/images/thumbs/nudev2-' + Math.floor((Math.random() * 5) + 1) + '-S.jpg',

        count_map: {
            li:             'logged_in',
            pv:             'viewed_profile',
            vf:             'viewed_feed',
            hf:             'hovered_feed',
            fa:             'favorite_added',
            fr:             'friend_request',
            nf:             'now_friends',
            want_to_meet:   'want_to_meet',
            pr:             'pic_rated',
            cl:             'content_like',
            cc:             'content_comment',
            cr:             'comment_reply',
            vl:             'video_like',
            vc:             'video_comment',
            sl:             'status_like',
            sc:             'status_comment',
            pp:             'premium_purchase',
            mm:             'mutual_match',
            pc:             'private_chat',
            ss:             'stream_started',
            er:             'emoji_reaction',
            comments:       'comments',
            free_growl:     'free_growl',
        },
        ignore_count_types: ['fr','er'], // don't update count for friend requests
        moshpit_states: [
            'activity-pane-logged_in',
            'activity-pane-viewed_profile',
            'activity-pane-viewed_feed',
            'activity-pane-hovered_feed',
            'activity-pane-favorite_added',
            'activity-pane-want_to_meet',
            'activity-pane-pic_rated',
            'activity-pane-comments',
            'activity-pane-emoji_reaction'
        ],
        latest_older_time: {}
    };

    var gui = {
        init: function() {
            MoshPit.join(self.$el);
            this.$content          = self.$el.find('.pane-content');
            this.$count            = $('.nav-activity-count');
            this.$count_mobile     = $('.nav-activity-count-mobile');
            this.$count_list       = self.$el.find('ul.activity-counts-list');
            // this.$activity_filters = self.$el.find('#activity-filters');
            this.$activity_results = self.$el.find('#activity-list');

            // this.$pagination_first = self.$el.find('.pagination .first');
            // this.$pagination_prev  = self.$el.find('.pagination .prev');
            // this.$pagination_next  = self.$el.find('.pagination .next');
            this.$pagination_count = self.$el.find('.pagination .page-count');
            this.$nano_scroller    = self.$el.find(".nano");
            this.$activity_filter = self.$el.find('.btn-activity-filter');

            this.ActivityList = new self.app.views.ActivityList({
                el:         '#activity-list',
                users:      self.sdata.ActivityUsers,
                collection: self.sdata.Activities,
                childViewOptions: {
                    event_ns: self.moduleName
                }
            });
            this.ActivityList.render();
        }
    };

    var util = {
        // clear out both ActivityUsers and Activities collection (shows emptyView for collection)
        reset_collections: function() {
            self.sdata.ActivityUsers.reset();
            self.sdata.Activities.reset();
        },
        handle_max_growls: function() {
            var count = $('#jGrowl .jGrowl-notification:visible').length;

            if (count > data.max_growls) {
                var end_index = (count - data.max_growls);
                $('#jGrowl > .jGrowl-notification:visible').slice(0, end_index).remove();
            }
        },
        add_to_queue: function(activity_type, json, show_func) {
            var queue_obj = {
                activity_type: activity_type,
                json: json,
                func: show_func
            };
            // console.warn('ActivityPage add_to_queue called... queue_obj: ', queue_obj);

            // add to array/queue of activities to display
            data.queue.push(queue_obj);

            // setup the setInterval timer/loop if it isn't running already
            if (!data.queue_interval_ref) {

                data.queue_interval_ref = setInterval(function() {
                    // console.warn('growl_type in setInterval: ', type);

                    // clear the setInterval timer if we're out of growls to display
                    if (!data.queue.length) {
                        clearInterval(data.queue_interval_ref);

                        data.queue_interval_ref = null;
                        return;
                    }


                    // don't show growls when there are open msg thread(s)
                    // var open_threads = GP.reqres.request('MessagePane.Thread:get_open_threads');
                    // if (open_threads && open_threads.length) {
                    //     return;
                    // }
                    if ($('.message-thread.docked').length) {
                        return;
                    }

                    // don't show growls on certain pages/uri paths
                    var show_popups = GP.reqres.request('Page:can_show_popups');
                    if (show_popups === false) {
                        return;
                    }

                    // var type = data.queue[0].growl_type;
                    var next = data.queue[0];
                    // console.warn('Activity queue setInterval next obj: ', next);

                    var next_type = next.activity_type;
                    var next_json = next.json;
                    var is_growl  = next_type === 'growl' ? true : false;
                    var organic   = (next_json.hasOwnProperty('organic') && next_json.organic === true);

                    // ensure we only show another growl for specific whitelabels once every 5 minutes
                    if (_util.check_limited_growls_host() && is_growl && !organic) {
                        var current_ts  = Math.floor(Date.now() / 1000);
                        var last_seen   = $.cookie('limited_growls');
                        var time_period = (5 * 60); // 5 minutes

                        // don't show if within the time_period window from last time
                        if (last_seen && (last_seen > (current_ts - time_period))) {
                            return;
                        }

                        // set cookie with timestamp for last limited growls shown
                        $.cookie('limited_growls', current_ts);
                    }

                    // shift the first growl off the beginning of the array/queue and call function to display
                    var growl_obj = data.queue.shift();
                    growl_obj.func();

                }, data.queue_interval);
            }
        }
    };

    var apis = {
        get_activity_feed: function(activity_type, page) {
            var ts = null;
            data.fetching_page = true;
            gui.$activity_results.hide();
            _util.gui.toggle_loading_spinner(true, self.el);

            var filter = $.trim(String(activity_type).toLowerCase());
                filter = (filter == 'undefined') ? "all" : filter;

            // won't need this when we have real ctimes for activities
            if (self.sdata.Activities.length > 0) {
                var index = self.sdata.Activities.length - 1;
                var last  = self.sdata.Activities.at(index);

                if (_util.check_obj(last)) {
                    ts = last.get('ctime');
                }
            }

            var api_data = {
                last_ctime:  ts,
                filter_type: filter,
                page:        page
            };

            if (filter === 'friends') {
                api_data.filter_friends = true;
            }

            self.api.json('user.notify_json', {
                data: api_data,
                success: events.add_activities
            });
        }
    };

    var events = {
        init: function() {
            // event to trigger from Cometd
            vent.on(self.moduleName+":show", this.show);

            // activity notifications are added to a queue instead of directly into activity pane/growl
            vent.on(self.moduleName+":add_activity", this.add_to_queue);
            vent.on(self.moduleName+":add_friend_request", this.add_friend_request);
            // vent.on(self.moduleName+":add_jgrowl_notification", this.add_jgrowl_notification);

            // add special growl notification to reload page and refresh js/css
            vent.on(self.moduleName+":add_reload_growl", this.add_reload_growl);

            // add matchgame reminder growl for users that never played the match game
            vent.on(self.moduleName+":add_matchgame_reminder_growl", function(json) {
                // only one matchgame reminder growl open at a time
                if (data.matchgame_reminder_growl_open === true) {
                    return;
                }

                util.add_to_queue('growl', json, function() {
                    events.add_matchgame_reminder_growl(json);
                });    
            });

            vent.on('Nanoscroller:activity-pane:setup', function() {
                gui.$nano_scroller.nanoScroller(_util.configs.nanoScroller);
                gui.$nano_scroller.nanoScroller({ scroll: 'top' });
            });

            // update flag to allow/hide growls (outside other business logic)
            vent.on(self.moduleName+":hide_growls", this.hide_growls);

            // gui.$content.on('scroll', this.handle_list_scroll);

            // gui.$activity_filters.on('change',this.change_filter);
            // gui.$pagination_first.on('click', this.first_page);
            // gui.$pagination_prev.on('click', this.prev_page);
            // gui.$pagination_next.on('click', this.next_page);

            gui.$activity_filter.on('click', this.change_filter);

            self.$el.find('.activity-counts-list li').on('click', this.handle_count_list);

            // if we're a free male seeking women start the loop that pops free growls
            if (GP.sdata.my_user.membership == 'FREE' && GP.sdata.my_user.gender == 'MAN' && GP.sdata.my_user.seeking.indexOf('WOMAN') !== -1) {

                // increase time between growls for free men seeking women
                // and setup free growl timer
                data.queue_interval = 20000;
                setTimeout(events.free_growl, 30000);
            }

            // grab notification/activity count(s)
            this.change_filter();
        },
        handle_count_list: function() {
            var type = $(this).data('type');
            // gui.$activity_filters.val(type).trigger('change');

            $('.activity-counts-list li').removeClass('bold');
            $(this).addClass('bold');
        },
        show: function() {
            // clear our counters when this pane is shown
            events.clear_counts();

            // show this pane and setup the nanoscroller once it has been shown
            self.$el.show(400, function(e) {
                // trigger event to whatever module is listening for setting up nanoscroll
                vent.trigger('Nanoscroller:activity-pane:setup');
            });
        },
        // first_page: function() {
        //     data.curr_page = 1;
        //     apis.get_activity_feed(gui.$activity_filters.val(), 1);
        // },
        // prev_page: function() {
        //     if (data.fetching_page === true || (data.curr_page === 1)) {
        //         return; // currently fetching a page or no more pages... gtfo.
        //     }
        //     data.curr_page--;
        //     apis.get_activity_feed(gui.$activity_filters.val(), data.curr_page);
        // },
        // next_page: function() {
        //     if (data.fetching_page === true || (data.curr_page >= data.total_pages)) {
        //         return; // currently fetching a page or no more pages... gtfo.
        //     }
        //     data.curr_page++;
        //     apis.get_activity_feed(gui.$activity_filters.val(), data.curr_page);
        // },
        handle_list_scroll: function(evnt) {
            if (data.fetching_page === true || (data.curr_page >= data.total_pages)) {
                return; // currently fetching a page or no more pages... gtfo.
            }

            var scroll_pos = Number($(this).scrollTop()) + Number($(this).innerHeight());
            var scroll_tot = Number($(this).prop('scrollHeight'));

            if (scroll_pos >= (scroll_tot-20)) {
                apis.get_activity_feed();
            }
        },
        change_filter: function(evt) {
            var filter  = 'all';

            data.curr_page = 1;

            if (evt && evt.currentTarget) {
                filter = $(this).data('filter');
                gui.$activity_filter.removeClass('active');
                $(this).addClass('active');
            }

            events.clear_states();
            MoshPit.add_state(self.el + '-' + filter);

            apis.get_activity_feed(filter, data.curr_page);
        },
        clear_states: function() {
            for (var i = 0; i < data.moshpit_states.length; i++) {
                MoshPit.remove_state(data.moshpit_states[i]);
            }
        },
        add_activity_user: function(user, options) {
            //console.trace('add_activity_user user: ', user);
            var max_content_rating = GP.sdata.my_user.max_content_rating;

            if (typeof user != 'undefined' && user) {
                var c_options = (typeof options != 'undefined' && options) ? options : {remove:false,add:true,merge:true};

                //user.pic = user['max_content_' + max_content_rating + '_pic'];

                if (user.pic) {
                    user.pic = _util.strip_http_scheme(user.pic);
                }
                self.sdata.ActivityUsers.set(user, c_options);
                return events.get_activity_user(user.duid);
            }
        },
        get_activity_user: function(duid) {
            //console.trace('get_activity_user user: ', self.sdata.ActivityUsers.get(duid));
            if (typeof duid != 'undefined' && duid) {
                var tmp_user = self.sdata.ActivityUsers.get(duid);
                if (tmp_user) {
                    return tmp_user;
                }
            }
            return false;
        },
        // combine add_activity and add_jgrowl_notification calls into one queue
        // and those that only previously triggered a growl will call add_jgrowl_notification
        // and all others will use add_activity method
        add_to_queue: function(json, growl_only) {
            // console.trace('ActivityPane add_to_queue... json: ', json);
            // console.warn('ActivityPane add_to_queue... growl_only: ', growl_only);
            events.reset_divider_val();
            if (growl_only === true) {
                util.add_to_queue('growl', json, function() {
                    events.add_jgrowl_notification(json);
                });
            } else {
                util.add_to_queue('activity', json, function() {
                    events.add_activity(json);
                });
            }
        },
        add_activity: function(json) {
             // console.trace('add_activity json: ', json);

            var max_content_rating = GP.sdata.my_user.max_content_rating;

            // return if bank compliance site
            if (_bank_site === true) {
                return;
            }

            // add to activity feed... check for fling2/3 styles of activity messages
            if (json.hasOwnProperty('user')) {
                json.user.pic = _util.select_rated_image(json.user, max_content_rating, _wl_max_rating); 
                json.user.online_status = (json.user.online_status ? json.user.online_status : 'OFFLINE');
                events.add_activity_user(json.user);
            } else {
                var tmp_user = {
                    duid: json.duid,
                    username: json.header,
                    short_name: json.header,
                    pic: _util.select_rated_image(json, max_content_rating, _wl_max_rating),
                    online_status: (json.online_status ? json.online_status : 'OFFLINE')
                };

                events.add_activity_user(tmp_user);
            }
            if (json.hasOwnProperty('activity')) {
                self.sdata.Activities.set(json.activity,{remove:false,add:true,merge:true});
            } else {
                var tmp_activity = {
                    id: data.count_map[json.type] + ":" + json.duid,
                    duid: json.duid,
                    type: json.type,
                    text: json.text,
                    ctime: Math.round(new Date().getTime() / 1000)
                };

                if (json.billing_url) {
                    tmp_activity.billing_url = json.billing_url;
                }

                self.sdata.Activities.set(tmp_activity,{remove:false,add:true,merge:true});
            }

            // update counts if pane is not shown
            if (self.$el.css('display') != 'block' && data.count_map.hasOwnProperty(json.type)) {
                var type = data.count_map[json.type];
                events.update_count(type, data.counts[type] + 1);

                // don't update activity total count for things like friend requests
                if ($.inArray(json.type, data.ignore_count_types) === -1) {
                    events.increment_new_count();
                }
            }

            // add jgrowl notification for appropriate types
            if ($.inArray(json.type, data.jgrowl_types) !== -1) {
                events.add_jgrowl_notification(json);
            }

            // add friend request
            if (json.type == 'fr') {
                // trigger add_friend_request in friend pane module
                vent.trigger("FriendPane:add_friend_request", json);
            }

            // shift recent divider to the top
            self.sdata.Activities.each(function(model) {
                if (model.get('type') === 'divider_recent') {
                    self.sdata.Activities.remove(model);
                    model.set('ctime', Math.round(new Date().getTime() / 1000));
                    self.sdata.Activities.unshift(model);
                }
            });

            // TODO: fix this
            // doesn't automatically resort, need to re-render :-/
            gui.ActivityList.render();
        },
        add_jgrowl_notification: function(json) {
            // console.trace('add_jgrowl_notification called... json: ', json);

            // return if user disabled receiving this type of message
            if (typeof GP.sdata.my_user.notification_settings !== 'undefined') {
                var user_notification_settings = GP.sdata.my_user.notification_settings;
                if (
                    !user_notification_settings.NEWMESSAGE          && json.type == 'new_message'
                    || !user_notification_settings.FRIENDREQUEST    && json.type == 'fr'
                    || !user_notification_settings.NEWMATCH         && json.type == 'mm'
                    || !user_notification_settings.VIDEOCHAT        && json.type == 'pc'
                    || !user_notification_settings.MATCHLIKE        && json.type == 'ml'
                    || !user_notification_settings.QSCORE           && json.type == 'qs'
                    || !user_notification_settings.COMMENTS         && json.type == 'cc'
                    || !user_notification_settings.COMMENTS         && json.type == 'vc'
                    || !user_notification_settings.FAVORITE         && json.type == 'fa'
                ) {
                    return;
                }
            }

            var max_content_rating = GP.sdata.my_user.max_content_rating;
            var mobile_view = (MoshPit.get_size() == 'mobile') ? true : false;
            var rdrawer_shown = GP.request('RightDrawer:is_shown');
            var thread_maximized = GP.request('MessagePane.Thread:maximized');

            // show the growl for private videochat requests
            var force_show_growl = (json.type == 'pc' || json.type == 'er') ? true : false;

            if ($.inArray(json.type, ['free_growl','generic']) === -1 && (mobile_view && rdrawer_shown) || thread_maximized || !self.sdata.my_user.show_growls) {
                if (force_show_growl === false) {
                    return;
                }
            }

            // return if bank compliance site
            if (_bank_site === true) {
                return;
            }

            // return if hide_growls flag was set to true from elsewhere in the codebase
            if (data.hide_growls === true && force_show_growl === false) {
                return;
            }

            var $growl,     // jGrowl notification element clones from templates
                growl_func; // function to call

            // add jgrowl notificaiton here
            var defaultParams = {
                type:      '',
                thread_id: '',
                content_id: null,
                pic:       '',
                header:    '',
                text:      ''
            };
            json = $.extend(defaultParams, json);
            var header = _util.check_obj(json.header) ? json.header : json.user.username;
            var text = _util.check_obj(json.text) ? json.text : json.activity.text;
            var growl_duid = _util.check_obj(json.duid) ? json.duid : json.user.duid;
            var profile_url = '/members/user/profile/?duid=' + growl_duid;
            var content_id = (json.activity && json.activity.content_id) ? json.activity.content_id : null;
            var content_duid = (json.activity && json.activity.content_duid) ? json.activity.content_duid : null;
            var premium_content_id = (json.activity && json.activity.premium_content_id) ? json.activity.premium_content_id : null;
            var billing_url = null;
            if (json.activity && json.activity.billing_url) {
                billing_url = json.activity.billing_url;
            } else if (json.billing_url) {
                billing_url = json.billing_url;
            }

            var pic;
            if (_util.check_obj(json['max_content_' + max_content_rating + '_pic'])) {
                pic = _util.select_rated_image(json, max_content_rating, _wl_max_rating);
            } else {
                pic = _util.select_rated_image(json.user, max_content_rating, _wl_max_rating);
            }

            // replace http://domain.com img src with //domain.com so http or https can be used where needed
            pic = _util.strip_http_scheme(pic);

            // force medium pic if not a premium upload growl
            if (json.type == 'pu') {
                pic = json.premium_thumb;
            } else {
                pic = pic.replace('-S.jpg', '-M.jpg');
            }

            if (json.type == 'new_message' && _util.check_obj(json.thread_id)) {
                // don't show growl if MessagePane:shown or user is free (free users have new messages pop automatically)
                if (GP.request('MessagePane:shown') || GP.sdata.my_user.membership == 'FREE') {
                    return true;
                }

                if (_util.check_nested(json, 'user.duid')) {
                    var user_model = events.get_activity_user(json.user.duid);
                    if (typeof user_model == 'undefined' || !user_model) {
                        if (json.user) {
                            user_model = events.add_activity_user(json.user);
                        }
                    }

                    $growl = $("#jgrowl-templates .new-message").clone();
                    if (_util.check_obj(pic)) {
                        $growl.find('.thumb').css('background-image', 'url(' + pic + ')');
                    }

                    $growl.find('.header').text(header);
                    $growl.find('.text').text(text);

                    var sticky_bool = (self.sdata.my_user.gender == "WOMAN") ? false : true;

                    // is the new_message and activity/system msg or organic msg from another user?
                    var msg_type = (json.hasOwnProperty('organic') && json.organic === true) ?
                                   'new_message_organic' :
                                   'new_message';

                    // trigger showing growl
                    $.jGrowl($growl, {
                        sticky: sticky_bool,
                        life: data.growl_expire,
                        afterOpen: util.handle_max_growls,
                        // setup open thread in message pane when you click the jGrowl notification
                        open: function(a,$ele,c) {
                            // add click bind to close button
                            $ele.parents('.jGrowl-notification').children('.jGrowl-close').one('click', function(e) {
                                events.jgrowl_closed_manually();
                            });

                            // .one to ensure we only fire the click event once
                            $ele.find('.notification-body').one('click', function(e) {
                                e.preventDefault();
                                e.stopImmediatePropagation();

                                var $spin  = $ele.find('.spinner-container');
                                $spin.addClass('show').spin('small');

                                if (_util.check_obj(user_model)) {
                                    user_model.thread_json()
                                        .done(function(thread_json) {
                                            if (_util.check_obj(thread_json)) {
                                                 // vent.trigger('MessagePane.Inbox:load_thread_external', thread_json);
                                                vent.trigger('MessagePane:send_message', growl_duid, thread_json);
                                            }
                                        })
                                        .always(function() {
                                            $spin.removeClass('show').spin(false);
                                            $ele.trigger('jGrowl.close');
                                        })
                                        .fail(function() {});
                                }
                            });
                        }
                    });
                }
            } else if (json.type == 'free_growl' || json.type == 'pu') {
                $growl = $("#jgrowl-templates .new-message").clone().removeClass('new-message');

                var btn_txt = (json.type == 'pu') ? js_lang.check_it_out : js_lang.start_chatting;
                text += '<br><button type="button" class="btn btn-primary">'+btn_txt+'</button>';
                $growl.attr('href', profile_url).addClass('clearfix');
                $growl.find('.thumb').css('background-image', 'url(' + pic + ')');
                $growl.find('.header').text(header);
                $growl.find('.text').html(text);

                // blur the image for premium upload growls
                if (json.type == 'pu') {
                    $growl.find('.thumb').css('filter', 'blur(3px)');
                }

                $.jGrowl($growl, {
                    sticky: true,
                    theme: 'free-growl',
                    afterOpen: util.handle_max_growls,
                    open: function(a,$ele,c) {
                        // add click bind to close button
                        $ele.parents('.jGrowl-notification').children('.jGrowl-close').one('click', function(e) {
                            events.jgrowl_closed_manually();
                        });

                        // .one to ensure we only fire the click event once
                        $ele.find('.notification-body').one('click', function(e) {
                            e.preventDefault();
                            e.stopImmediatePropagation();
                            self.vent.trigger("Page:redirect", (billing_url || profile_url));
                            $ele.trigger('jGrowl.close');
                        });
                    }
                });

            } else if ($.inArray(json.type, data.jgrowl_types) !== -1) {

                $growl = $("#jgrowl-templates .non-new-message").clone();
                $growl.attr('href', '/members/user/profile/?duid=' + growl_duid);
                $growl.find('.thumb').css('background-image', 'url(' + pic + ')');
                $growl.find('.header').text(header);
                $growl.find('.text').text(text);

                // show growl for longer for forced growls (private videochat requests 'pc')
                // var growl_expire = force_show_growl ? 30000 : data.growl_expire;
                var growl_expire = data.growl_expire; // 5s

                $.jGrowl($growl, {
                    // sticky: true,
                    life: growl_expire,
                    afterOpen: util.handle_max_growls,
                    open: function(a,$ele,c) {
                        // add click bind to close button
                        $ele.parents('.jGrowl-notification').children('.jGrowl-close').one('click', function(e) {
                            events.jgrowl_closed_manually();
                        });

                        var redirect_url = null;
                        if (json.activity.redirect_url || json.type == 'pc') {
                            redirect_url = json.activity.redirect_url;
                            $ele.parents('.jGrowl-notification').addClass('jGrowl-bg-highlight');
                            // $ele.find('p').css('color', '#333');
                            $ele.find('p').css({
                                "color": '#fff',
                                "font-weight": "bold"
                            });
                        }

                        // .one to ensure we only fire the click event once
                        $ele.find('.notification-body').one('click', function(e) {
                            e.preventDefault();
                            e.stopImmediatePropagation();
                            if (content_id) {
                                self.vent.trigger('ContentViewer:show_content', content_id, content_duid);
                            } else if (premium_content_id) {
                                self.vent.trigger('Premium:viewer', {
                                    premium_content_id: premium_content_id,
                                    duid: content_duid
                                });
                            } else if (redirect_url) {
                                window.location.href = redirect_url;

                            // open msg thread for private videochat request growls
                            } else if (json.type == 'pc') {
                                self.api.json('/members/msg/get_thread_json/', {
                                    data: { duid: growl_duid },
                                    success: function(json_response) {
                                        if (json_response && json_response.threads) {
                                            self.vent.trigger('MessagePane.Inbox:load_thread_external', json_response);
                                        }
                                    }
                                });

                            } else {
                                self.vent.trigger("Page:redirect",profile_url);
                            }
                            $ele.trigger('jGrowl.close');
                        });
                    }
                });
            }

        },
        jgrowl_closed_manually: function() {
            data.growls_closed++;

            if (GP.sdata.my_user.membership != 'FREE' && !$.cookie('settings_growl_shown') && data.growls_closed >= data.settings_growl_threshhold) {
                var $growl = $("#jgrowl-templates .jgrowl-special.edit-account").clone();

                $growl.find('.header').text(js_lang.growl.settings.header);
                $growl.find('.text').text(js_lang.growl.settings.text);

                $.jGrowl($growl, {
                    sticky: true,
                    theme: 'settings', // class added to jGrowl notification
                    open: function(a,$ele,c) {
                        data.settings_growl_shown = true;
                        $.cookie('settings_growl_shown', 1);

                        // .one to ensure we only fire the click event once
                        $ele.find('.notification-body').one('click', function(e) {
                            e.preventDefault();
                            e.stopImmediatePropagation();

                            self.vent.trigger("Page:redirect", $growl.attr('href'));
                            $ele.trigger('jGrowl.close');
                        });
                    }
                });
            }
        },
        add_reload_growl: function() {
            // if we already have a reload growl open, just return
            if (MoshPit.has_state('reload-growl-shown')) {
                return;
            }

            var current_ts  = Math.floor(Date.now() / 1000);
            var last_seen   = $.cookie('reload_growl');
            var time_period = (60 * 10); // 10 minutes

            // don't show if within the time_period window from last time
            if (last_seen && (last_seen > (current_ts - time_period))) {
                return;
            }

            // set session cookie
            $.cookie('reload_growl', current_ts);

            MoshPit.add_state('reload-growl-shown');
            var $growl = $("#jgrowl-templates .jgrowl-special.reload-page").clone();

            $growl.find('.header').text(js_lang.growl.reload.header);
            $growl.find('.text').text(js_lang.growl.reload.text);

            $.jGrowl($growl, {
                sticky: true,
                theme: 'reload', // class added to jGrowl notification
                open: function(a,$ele,c) {
                    // get rid of close button
                    $ele.parent().siblings('.jGrowl-close').remove();

                    // .one to ensure we only fire the click event once
                    $ele.find('.notification-body').one('click', function(e) {
                        e.preventDefault();
                        e.stopImmediatePropagation();

                        // use true to force reload and ignore cache
                        document.location.reload(true);
                    });
                }
            });
        },
        add_matchgame_reminder_growl: function(json) {
            var header = 'Play Match game and get more action!';
            var text = '<button type="button" class="btn btn-primary">'+js_lang.play_the_game+'</button>';
            var pic = 'https://cachemd.cdnhost2000xl.com/images/fl_matchgame_' + json.pic + '_200px.png';
            var matchgame_url = '/members/user/hotpick/?grwl=1';

            var $growl = $("#jgrowl-templates .new-message").clone().removeClass('new-message');
            $growl.find('.thumb').css('background-image', 'url(' + pic + ')');
            $growl.find('.header').text(header);
            $growl.find('.text').html(text);

            $.jGrowl($growl, {
                sticky: true,
                theme: 'free-growl',
                afterOpen: util.handle_max_growls,
                close: function(a,$ele,c) {
                    data.matchgame_reminder_growl_open = false;
                },
                open: function(a,$ele,c) {
                    data.matchgame_reminder_growl_open = true;

                    // add click bind to close button
                    $ele.parents('.jGrowl-notification').children('.jGrowl-close').one('click', function(e) {
                        events.jgrowl_closed_manually();
                    });

                    // .one to ensure we only fire the click event once
                    $ele.find('.notification-body button').one('click', function(e) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        self.vent.trigger("Page:redirect", (matchgame_url));
                        $ele.trigger('jGrowl.close');
                    });
                }
            });
        },
        clear_counts: function() {
            $.each(data.counts, function(key, obj) {
                events.update_count(key, 0);
            });
            gui.$count.empty();
            gui.$count_mobile.empty().addClass('gp-hidden');
            MoshPit.remove_state(self.el + '-new-count');
        },
        update_count: function(type, c) {
            var count = Number(c);
                count = (count == 'NaN' || count < 0) ? 0 : count;

            if (data.counts.hasOwnProperty(type)) {
                data.counts[type] = count;

                var $ele = gui.$count_list.find('li.' + type + ' span');
                if (count === 0) {
                    $ele.empty();
                } else {
                    $ele.text(count);
                }
            }
        },
        increment_new_count: function() {
            gui.$count.text(++data.counts.total_new);
            gui.$count_mobile.text(data.counts.total_new).removeClass('gp-hidden');

            if (data.counts.total_new > 0) {
                MoshPit.add_state(self.el + '-new-count');
            }
        },
        add_activities: function(json) {
            var max_content_rating = GP.sdata.my_user.max_content_rating;
            events.reset_divider_val();
            data.fetching_page = false;
            _util.gui.toggle_loading_spinner(false, self.el);
            gui.$activity_results.show();

            if (typeof json != 'undefined' && json) {
                if (json.counts) {
                    /*
                    if (json.counts.hasOwnProperty('friend_request_count')) {
                        // update friend request count
                        vent.trigger('FriendPane:update_count', json.counts.friend_request_count);
                    }
                    if (json.counts.hasOwnProperty('new_msg_count')) {
                        // update unread message count
                        vent.trigger('MessagePane:update_count', json.counts.new_msg_count);
                    }
                    */
                    if (json.counts.hasOwnProperty('fav_count')) {
                        // update favorite count
                        events.update_count('favorite', json.counts.fav_count);
                    }
                    if (json.counts.hasOwnProperty('viewed_profile')) {
                        // update viewed_profile count
                        events.update_count('viewed_profile', json.counts.viewed_profile);
                    }
                    if (json.counts.hasOwnProperty('content_like')) {
                        // update viewed_profile count
                        events.update_count('content_like', json.counts.content_like);
                    }
                }

                var users = [];
                if (json.users && json.users.length) {
                    for (var i=0; i<json.users.length; i++) {
                        if (json.users[i].hasOwnProperty('duid')) {
                            json.users[i].duid = Number(json.users[i].duid);

                            json.users[i].pic = _util.select_rated_image(json.users[i], max_content_rating, _wl_max_rating);
                            users.push(json.users[i]);
                        }
                    }
                }
                self.sdata.ActivityUsers.reset(users);

                if (json.activities && json.activities.length) {

                    $.each(json.activities, function(index, obj) {
                        let temp_obj = {
                            id: 'divider:'+obj.id,
                            duid: obj.duid,
                            content_id: '0000',
                            text: 'divider',
                            ctime: obj.ctime,
                        };

                        let day_diff = GP.Util.day_diff(obj.ctime);
                        if (!GP.activity_divider.recent && day_diff <= 5) {
                            GP.activity_divider.recent = true;
                            temp_obj.type = 'divider_recent';
                            // collection is sorted by ctime. Make sure recent divider time is newest.
                            temp_obj.ctime = Math.round(new Date().getTime() / 1000);
                            json.activities.unshift(temp_obj);
                        }

                        if (day_diff >= 6) {
                            if (_.isEmpty(data.latest_older_time)) {
                                data.latest_older_time = {
                                    days: day_diff,
                                    ctime: obj.ctime
                                };
                            } else if (day_diff <= data.latest_older_time.days) {

                                // set ctime to be 1 minute later
                                let new_date = new Date(obj.ctime * 1000);
                                new_date.setMinutes(new_date.getMinutes() + 1);

                                data.latest_older_time = {
                                    days: day_diff,
                                    ctime: Math.floor(new_date.getTime() / 1000)
                                };
                            }
                        }
                    });

                    if (!_.isEmpty(data.latest_older_time)) {
                        GP.activity_divider.older = true;
                        let temp_obj = {
                            id: 'divider:' + data.latest_older_time.ctime,
                            type: 'divider_older',
                            duid: data.latest_older_time.ctime,
                            content_id: '0000',
                            text: 'divider',
                            ctime: data.latest_older_time.ctime,
                        };
                        json.activities.unshift(temp_obj);
                    }

                    self.sdata.Activities.reset(json.activities);
                } else {
                    util.reset_collections();
                }

                if (json.hasOwnProperty('total_pages')) {
                    data.total_pages = Number(json.total_pages);
                }
                if (json.hasOwnProperty('current_page')) {
                    data.curr_page = Number(json.current_page);
                }
            } else {
                util.reset_collections();
            }

            MoshPit.add_state(self.el + '-all');
            vent.trigger('Nanoscroller:activity-pane:setup');
        },
        free_growl: function() {
            var sec_since_join  = Math.abs(new Date() - new Date(GP.sdata.my_user.join_date)) / 1000;
            var show_popups = GP.reqres.request('Page:can_show_popups');

            // in case we need to change these in the future server side
            var min_time = window._fg_min_time || 65000;
            var max_time = window._fg_max_time || 105000;

            var next_check = Math.floor(Math.random() * (max_time - min_time + 1) + min_time);
            if (show_popups && sec_since_join > 30) {
                $.get('/members/user/free_growl/', { 'fg': 1 }, function(res) {
                    if (!res.fg || !res.fg.limit_reached) {
                        setTimeout(events.free_growl, next_check);
                    }
                });
            } else {
                setTimeout(events.free_growl, next_check);
            }
        },
        hide_growls: function(bool_val) {
            data.hide_growls = !!bool_val; // ensure we set a boolean value
        },
        // reset divider flag
        reset_divider_val: function() {
            GP.activity_divider.older = false;
            GP.activity_divider.recent = false;
        }
    };

    this.addInitializer(function(){
        self.el  = 'activity-pane';
        self.$el = $('#' + self.el);

        data.init();
        gui.init();
        events.init();
    });
});

